type INetcoreData = {
  firstName?: string;
  emailAddress?: string;
  lastName?: string;
  mobileNumber?: string;
};

export const registerNetcoreActivity = (data: INetcoreData, name: string) => {
  // Check if smartech is defined and is a function
  if (typeof window?.smartech === 'function') {
    window.smartech('identify', data?.emailAddress);
    window.smartech('dispatch', name, {
      FIRST_NAME: data?.firstName,
      EMAIL: data?.emailAddress,
      LAST_NAME: data?.lastName,
      MOBILE: data?.mobileNumber,
    });
  } else {
    console.error('Smartech is not initialized or is not a function');
  }
};

// export const handleNetcoreReg = (data: any) => {
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   //@ts-ignore
//   window?.smartech(
//     'contact',
//     'LIST IDENTIFIER',
//     {
//       'pk^email': data?.emailAddress,
//       FIRST_NAME: data?.firstName,
//       EMAIL: data?.emailAddress,
//       LAST_NAME: data?.lastName,
//       MOBILE: data?.mobileNumber,
//     },
//     function () {
//       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//       //@ts-ignore
//       window?.smartech('identify', data?.emailAddress);
//       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//       //@ts-ignore
//       window?.smartech('dispatch', 'Register', {
//         email: data?.emailAddress,
//         FIRST_NAME: data?.firstName,
//         LAST_NAME: data?.lastName,
//         MOBILE: data?.mobileNumber,
//       });
//     },
//   );
// };

export const handleNetcoreReg = (data: any) => {
  // Check if smartech is defined and is a function
  if (typeof window?.smartech === 'function') {
    window.smartech(
      'contact',
      'LIST IDENTIFIER',
      {
        'pk^email': data?.emailAddress,
        FIRST_NAME: data?.firstName,
        EMAIL: data?.emailAddress,
        LAST_NAME: data?.lastName,
        MOBILE: data?.mobileNumber,
      },
      function () {
        if (typeof window?.smartech === 'function') {
          window.smartech('identify', data?.emailAddress);
          window.smartech('dispatch', 'Register', {
            email: data?.emailAddress,
            FIRST_NAME: data?.firstName,
            LAST_NAME: data?.lastName,
            MOBILE: data?.mobileNumber,
          });
        } else {
          console.error('Smartech is not initialized or is not a function');
        }
      },
    );
  } else {
    console.error('Smartech is not initialized or is not a function');
  }
};
